module.exports = __webpack_public_path__ + "img/honeycomb.d9130fe1.svg";